import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { PlaceSetService } from '../services/place-set.service';

@Injectable({
  providedIn: 'root',
})
export class FavoriteNameValidator implements AsyncValidator {
  constructor(private placesetService: PlaceSetService) {}
  validate = (control: AbstractControl) => {
    const { value } = control;
    const error: ValidationErrors = { duplicateName: true };
    return this.placesetService.favoritePlaceStore$.pipe(
      take(1),
      map((combinedPlaces) => {
        const duplicatePlace = combinedPlaces.find(
          (place) => place.PlaceName.toLowerCase() === value.toLowerCase()
        );
        return duplicatePlace ? error : null;
      }),
      catchError((err) => {
        return of(err);
      })
    );
  };
}
